import * as React from "react";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AssumedWrapCashHoldings } from "../../../../Common/PaymentsIn/AssumedWrapCashHoldings";
import { PensionProtection } from "../../../../Common/PaymentsIn/SIPP/PensionProtection";
import { RegularPayment } from "../../../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { RetirementAge } from "../../../../Common/PaymentsIn/SIPP/RetirementAge";
import { SinglePayment } from "../../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { TransferIn } from "../../../../Common/PaymentsIn/TransferIn/TransferIn";
import { IsRestrictedToPensionContributionWarningText, PaymentType, PensionTypesMap, processTypeEnum } from "../../../../Common/Resource/Contents";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import {
    needSingleContribution,
    needPostTransfer,
    isRestrictedToPensionContribution,
} from "../../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { nbPaymentsInMessages } from "../../../../NewBusinessWizard/Resource/Contents";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
interface IPaymentsInProps extends IProcessComponentProps {
    data: QuoteModel;
    processType?: ProcessType;
    HasExistingSIPP?: boolean;
}

interface IPaymentsInState {}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
        };
    };

    public isValid(): boolean {
        let isValid = super.isValid();
        const config = this.props.data.SelectedProducts.find((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        isValid = isValid && this.atLeastOneContribution();
        if (!this.atLeastOneContribution()) {
            this.props.showErrorMsgPopUp([nbPaymentsInMessages.atLeastOneContribution]);
        }
        const needSingleContributionFlag = needSingleContribution(config, this.props.data.PensionQuote);
        if (needSingleContributionFlag) {
            this.props.showErrorMsgPopUp([
                `Please add a contribution/transfer to support <Take Pension Benefits/Immediate Tax Free Cash>, or remove the ${
                    PensionTypesMap[config.PensionType]
                }`,
            ]);
        }
        const needPostTransferFlag = needPostTransfer(config, this.props.data.PensionQuote);
        if (needPostTransferFlag) {
            this.props.showErrorMsgPopUp([
                "Please add a Post Retirement Transfer, or remove the request to take income from the pension",
            ]);
        }
        var isRestrictedProtection = false;
        if (this.props.data?.PensionQuote?.HasPensionProtection && this.props.data?.PensionQuote?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.PensionQuote?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }

        return isValid && !needPostTransferFlag && !needSingleContributionFlag && !isRestrictedProtection;
    }

    private atLeastOneContribution(): boolean {
        const { data } = this.props;
        return (
            data.PensionQuote.ClientSinglePayment?.Money?.Amount > 0 ||
            data.PensionQuote.ThirdPartySinglePayment?.Money?.Amount > 0 ||
            data.PensionQuote.ClientRegularPayment?.Money?.Amount > 0 ||
            data.PensionQuote.ThirdPartyRegularPayment?.Money?.Amount > 0 ||
            data.PensionQuote.PensionTransfers?.length > 0 ||
            data.PensionQuote.EmployerSalaryDeductionSinglePayment?.Money?.Amount > 0 ||
            data.PensionQuote.EmployerSalaryDeductionRegularPayment?.Money?.Amount > 0 ||
            data.PensionQuote.EmployerSinglePayment?.Money?.Amount > 0 ||
            data.PensionQuote.EmployerRegularPayment?.Money?.Amount > 0
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const isImmediateTaxFreeLumpSum =
            data.SelectedProducts.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        const pensionInfo = data.SelectedProducts.find((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const isTransferPost =
            pensionInfo.PensionType == PensionType.None && pensionInfo.IsIncomePaymentDetailsSelected;
        return (
            <div>
                <h2>Payments in</h2>
                <SinglePayment
                    {...this.getProps("PensionQuote")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={[
                        PaymentType.Client,
                        PaymentType.ThirdParty,
                        PaymentType.EmployerSalaryDeduction,
                        PaymentType.Employer,
                    ]}
                    subAccountType={pensionInfo.SubAccountType}
                    hasPaymentMethod={false}
                    processType={
                        this.props.processType == ProcessType.NB
                            ? processTypeEnum.Quote
                            : processTypeEnum.NewQuoteExistingClient
                    }
                    HasExistingSIPP={this.props.HasExistingSIPP}
                    IsDisqualifyingPensionCredits={pensionInfo.IsDisqualifyingPensionCredits}
                />
                <hr />
                {!isImmediateTaxFreeLumpSum && (
                    <RegularPayment
                        {...this.getProps("PensionQuote")}
                        clientInfo={this.props.data.ClientDetails}
                        checkBoxOption={[
                            PaymentType.Client,
                            PaymentType.ThirdParty,
                            PaymentType.EmployerSalaryDeduction,
                            PaymentType.Employer,
                        ]}
                        subAccountType={pensionInfo.SubAccountType}
                        hasContinue={false}
                        hasIndexation={true}
                        processType={
                            this.props.processType == ProcessType.NB
                                ? processTypeEnum.Quote
                                : processTypeEnum.NewQuoteExistingClient
                        }
                        HasExistingSIPP={this.props.HasExistingSIPP}
                        IsDisqualifyingPensionCredits={pensionInfo.IsDisqualifyingPensionCredits}
                    />
                )}
                <hr />
                <TransferIn
                    subAccountType={pensionInfo.SubAccountType}
                    data={this.props.data.PensionQuote.PensionTransfers}
                    jouneryType={
                        this.props.processType == ProcessType.NB
                            ? processTypeEnum.Quote
                            : processTypeEnum.NewQuoteExistingClient
                    }
                    HasExistingSIPP={this.props.HasExistingSIPP}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "PensionQuote"),
                            changes,
                            data.PensionQuote
                        )
                    }
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    isPost={isTransferPost}
                    onRef={(ref) => this.appendChild(ref)}
                    selectedProducts={this.props.data.SelectedProducts}
                    accountServiceProposition={this.props.data.AccountServiceProposition}
                    subAccountInstructionHierarchy={this.props.data?.PensionQuote?.HierarchyId}
                />
                <hr />
                <AssumedWrapCashHoldings {...this.getProps("AssumedHoldings")} />
            </div>
        );
    }
}
